module.exports = __webpack_public_path__ + "static/media/IMG_5892-min.40e2ced1.jpg";